import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {Router} from '@angular/router';
import {APP_ROUTE_PATH} from '@core/enums';
import {SOCKET_ROOM} from '@core/enums/events-buffer/socket/socket-rooms-enum';
import {INFORMATIVE_ROUTE_PATH} from '@core/enums/routes/informative-route-path.enum';
import { Logger } from '@core/interfaces/Logger';
import { NetworkConnectionService } from '@core/services/network-connection/network-connection.service';
import {SocketConnectionHandlerService} from '@core/services/socket/socket-connection-handler.service';
import {BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE} from '@discocil/fv-components';
import {Location} from '@features/service/domain/models/location.model';
import { SERVICE_STATE_SERVICE } from '@features/service/domain/tokens/service-state.token';
import {TranslateService} from '@ngx-translate/core';
import {ServiceLocationChangedEvent} from '@platform/event-bus/domain/events/service-location.event';
import {EVENT_BUS} from '@shared/domain/tokens/event-bus.token';
import {GlobalConfirmService} from '@shared/services/global-confirm/global-confirm.service';
import {mergeMap} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocationStatusService {
  private readonly networkConnectionService = inject(NetworkConnectionService);
  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);
  private readonly eventBus = inject(EVENT_BUS);
  
  private readonly socketConnectionHandlerService = inject(SocketConnectionHandlerService);
  private readonly globalConfirmService = inject(GlobalConfirmService);
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly logger = inject(Logger);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    //this.onNetworkConnectionListener();
    this.onCurrentLocationRemovedListener();
  }

  private onCurrentLocationRemovedListener(): void {
    this.eventBus.ofType(ServiceLocationChangedEvent)
      .pipe(
        mergeMap(() => this.serviceStateService.getLocationsFromServer()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((locations: Location[]) => {
        this.logger.debug(
          `[Socket 🔌] [Room: ${SOCKET_ROOM.locations} 🙎‍♂️🙍‍♀️] [Current location has been removed]`
        );
        this.socketConnectionHandlerService.sendUnsentSocketEvents();
        let route = [`/${APP_ROUTE_PATH.serviceConfiguration}`];

        if (!locations?.length) {
          route = [APP_ROUTE_PATH.info, INFORMATIVE_ROUTE_PATH.locations];
        }

        this.openRemovedCurrentLocationConfirm(route);
      });
  }

  private openRemovedCurrentLocationConfirm(route: string[]): void {
    this.globalConfirmService.open({
      noClose: true,
      icon: 'fas fa-face-frown',
      iconSize: 'text-3xl ',
      title: this.translateService.instant(
        'fv_confirm.current_location_removed.title'
      ),
      hideCloseIcon: true,
      message: this.translateService.instant(
        'fv_confirm.current_location_removed.subtitle'
      ),
      buttons: [
        {
          text: this.translateService.instant('global.understood'),
          color: BUTTON_COLOR.primary,
          size: BUTTON_SIZE.full,
          type: BUTTON_TYPE.filled,
          preventAutoClose: true,
          handler: (): void => {
            this.globalConfirmService.close();
            this.router.navigate(route, { replaceUrl: true });
          },
        },
      ],
    });
  }

  /*private checkLocationStatus(): void {
    forkJoin({
      locations: of(this.serviceStateService.getLocationsFromServer()),
      currentLocation: of(this.serviceStateService.getCurrentLocation()),
    })
      .pipe(first(), takeUntilDestroyed(this.destroyRef))
      .subscribe(({ locations, currentLocation }) => {
        const hasCurrentLocation = locations?.find(
          (location: Location) => location?.id === currentLocation?.id
        );

        if (currentLocation && !hasCurrentLocation) {
          this.locationService.notifyOnCurrentLocationRemoved();
        }
      });
  }

  private onNetworkConnectionListener(): void {
    this.networkConnectionService.onNetworkConnectionChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isInternetConnected: boolean) => {
        if (isInternetConnected) {
          this.checkLocationStatus();
        }
      });
  }*/
}

